export const NO_AUTHENTICATION:string = "NO_AUTHENTICATION";

export const AUTHENTICATION: string = "AUTHENTICATION";

export const AUTHORIZATION: string = "AUTHORIZATION"
